import ListaDesplegable from "./ListaDesplegable";
import { detalleCliente, filtrarClientes } from "../servicios/clientes";

export const ClienteOpcion = (cliente) => {
  const detalles = detalleCliente(cliente);
  return (
    <div className="cliente-opcion">
      <strong>
        {[cliente?.sCodigo, cliente?.sDescripcion].filter(Boolean).join(" - ") || "Cliente sin descripción"}
      </strong>
      {detalles.length > 0 && <small>{detalles.join(" · ")}</small>}
    </div>
  );
};

export default function SelectorClientes({
  Lista,
  Buscando,
  Error,
  Reintentar,
  CrearDesdeTexto,
  ...props
}) {
  return (
    <ListaDesplegable
      {...props}
      Lista={Lista}
      Buscando={Buscando}
      Error={Error}
      Reintentar={Reintentar}
      Filtrar={filtrarClientes}
      ItemTemplate={ClienteOpcion}
      MensajeVacio={CrearDesdeTexto ? "Presione Enter para usarlo como cliente nuevo" : "No hay clientes activos"}
      ActualizarSoloAlSeleccionar
      ConfirmarTexto={CrearDesdeTexto}
    />
  );
}
